import { addStyles } from 'ethcss'
import { mediaCSS, textSizes } from 'theme/media'
import { colors, IStyles, item, grid } from '../../../theme'

const historyFilterStyles: IStyles = {
    filterFields: {
        ...grid.p_mini,
        ...grid.space,
        fontSize: textSizes.normal,
        overflowY: 'auto',
        ...grid.pt_md,
    },
    filter: {
        ...item.rel,
        width: '111.9px',
        [mediaCSS.tabMini]: {
            ...grid.space,
        },
    },
    modalWrapper: {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'stretch',
        justifyContent: 'flex-end',
        padding: '36px 18px 36px 24px',
        backgroundColor: 'rgba(20, 24, 32, 0.48)',
        [mediaCSS.mob]: {
            padding: 12,
        },
    },
    zIndex: {
        zIndex: 999,
    },
    fieldWrapper: {
        ...grid.p_mini,
        ...grid.pt_none,
    },
    modalInner: {
        display: 'flex',
        width: 384,
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'calc(100vh - 72px)',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: colors.white,
        borderRadius: 12,
        boxShadow: '0 24px 64px rgba(20, 32, 56, 0.24)',
        [mediaCSS.mob]: {
            width: '100%',
            maxHeight: 'calc(100vh - 24px)',
        },
    },
    modalHeader: {
        display: 'flex',
        minHeight: 64,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        borderBottom: `1px solid ${colors.greyLight}`,
    },
    closeButton: {
        appearance: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        padding: 0,
        border: 0,
        borderRadius: 6,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#F3F5F8',
        },
    },
    modalBody: {
        flex: 1,
        overflowY: 'auto',
        padding: '20px 24px 24px',
    },
    selectorField: {
        paddingBottom: 16,
    },
    resetButton: {
        appearance: 'none',
        width: '100%',
        minHeight: 44,
        marginTop: 24,
        padding: '10px 16px',
        border: 0,
        borderRadius: 6,
        backgroundColor: '#F4F5F7',
        color: colors.blackLight,
        fontSize: 13,
        lineHeight: '18px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#EDEFF3',
        },
    },
    buttons: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 12,
        padding: '16px 24px',
        borderTop: `1px solid ${colors.greyLight}`,
        boxShadow: '0 -8px 24px rgba(28, 39, 60, 0.04)',
        [mediaCSS.mob]: {
            gridTemplateColumns: '1fr',
        },
    },
    actionButton: {
        minHeight: 42,
        borderRadius: '6px !important',
    },
    applyButton: {
        backgroundColor: '#3C7BF4 !important',
        borderColor: '#3C7BF4 !important',
        '&:hover': {
            backgroundColor: '#2F6FE8 !important',
        },
    },
    closeActionButton: {
        borderColor: '#E3E7EE !important',
        color: `${colors.blackLight} !important`,
    },
    checkItem: {
        ...grid.pb_mini,
        '&:last-child': {
            ...grid.pb_none,
        },
    },
    mobileScroll: {
        overflow: 'visible',
    },
}

addStyles(historyFilterStyles)
export default historyFilterStyles
